import {useEnvironment} from '@wix/yoshi-flow-editor'
import {useEffect} from 'react'
import {usePrevious} from '../../../../../../commons/hooks/use-previous'
import {usePageActions, usePageStateSelector} from '../../../hooks/state'
import {isReservationUnavailable} from '../../../selectors/reservation'

export const useCheckoutUnavailableCheck = () => {
  const {isEditor} = useEnvironment()
  const {openCheckoutUnavailable} = usePageActions()
  const reservationUnavailable = usePageStateSelector(isReservationUnavailable)
  const prevReservationUnavailable = usePrevious(reservationUnavailable)
  useEffect(() => {
    if (prevReservationUnavailable !== reservationUnavailable && reservationUnavailable && !isEditor) {
      openCheckoutUnavailable()
    }
  }, [isEditor, reservationUnavailable, prevReservationUnavailable, openCheckoutUnavailable])
}
